import { machineStatusName, machineTimeType, roundToOdd } from '@components/wallboard/components/functions';
import { WALLBOARD_TILE_LAYOUT } from '@components/wallboard/constants';
import { MachineTimeData, TargetTimeResult } from '@components/wallboard/types';

export const getTimelineLineHeight = (tileHeight: number): number =>
  roundToOdd(tileHeight * WALLBOARD_TILE_LAYOUT.TIMELINE_LINE_HEIGHT_RATIO);

export const getTargetTimeAndType = (data: MachineTimeData | null): TargetTimeResult => {
  const noData = { targetTime: null, targetTimeType: null };

  if (!data) {
    return noData;
  }

  const timePriority = [
    { value: data.scheduledTimeInSeconds, type: machineTimeType.SCHEDULED },
    { value: data.paidTimeInSeconds, type: machineTimeType.PAID },
    { value: data.idealTimeInSeconds, type: machineTimeType.IDEAL },
  ];

  const found = timePriority.find((item) => item.value > 0);

  return found ? { targetTime: found.value, targetTimeType: found.type } : noData;
};

export const getMachineDataByStatus = (batch: any, status: string): MachineTimeData => {
  const zero: MachineTimeData = {
    idealTimeInSeconds: 0,
    paidTimeInSeconds: 0,
    scheduledTimeInSeconds: 0,
  };

  if (!batch) {
    return zero;
  }

  const map: Record<string, MachineTimeData> = {
    [machineStatusName.Setup]: {
      idealTimeInSeconds: batch.idealSetupTimeInSeconds,
      paidTimeInSeconds: batch.paidSetupTimeInSeconds,
      scheduledTimeInSeconds: batch.scheduledSetupTimeInSeconds,
    },
    [machineStatusName.Active]: {
      idealTimeInSeconds: batch.idealActiveTimeAverageInSeconds,
      paidTimeInSeconds: batch.paidActiveTimeAverageInSeconds,
      scheduledTimeInSeconds: batch.scheduledActiveTimeAverageInSeconds,
    },
    [machineStatusName.Change]: {
      idealTimeInSeconds: batch.idealChangeTimeAverageInSeconds,
      paidTimeInSeconds: batch.paidChangeTimeAverageInSeconds,
      scheduledTimeInSeconds: batch.scheduledChangeTimeAverageInSeconds,
    },
  };

  return map[status] ?? zero;
};
